import React, { useState, useEffect } from 'react';
import { fetchShipmentsByFilters } from '../../services/api';
import './carrierPayment.css';

export default function CarrierPayment({ shipment_filters, onConfirm, onClose }) {
  const [shipments, setShipments] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [paymentNumber, setPaymentNumber] = useState('');

  const selectedShipmentsSum = () => {
    return shipments
      .filter(shipment => shipment.selected)
      .reduce((sum, shipment) => sum + parseFloat(shipment.carrier_price), 0);
  };

  useEffect(() => {
    const fetchData = async filters => {
      try {
        const fetchedData = await fetchShipmentsByFilters(filters, 'shipment_number');
        if (fetchedData && Array.isArray(fetchedData.results)) {
          const shipments = fetchedData.results;
          const extractedData = shipments.map(shipment => ({
            ...shipment,
            selected: false,
          }));
          setShipments(extractedData);
        } else {
          setShipments([]);
          console.error('La réponse ne contient pas de tableau "results"');
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        setShipments([]);
      }
    };

    const filterInputs = {};

    shipment_filters.forEach((value, key) => {
      if (value !== '') {
        filterInputs[key] = value;
      }
    });

    fetchData(filterInputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeInvoiceNumber = e => {
    setInvoiceNumber(e.target.value);
  };

  const handleChangePaymentDate = e => {
    setPaymentDate(e.target.value);
  };

  const handleChangePaymentNumber = e => {
    setPaymentNumber(e.target.value);
  };

  const handleSelectAll = () => {
    setShipments(shipments.map(shipment => ({ ...shipment, selected: true })));
  };

  const handleDeselectAll = () => {
    setShipments(shipments.map(shipment => ({ ...shipment, selected: false })));
  };

  const handleToggleSelect = index => {
    const newShipments = [...shipments];
    newShipments[index].selected = !newShipments[index].selected;
    setShipments(newShipments);
  };

  const onTriggerConfirm = e => {
    const selected = shipments.filter(shipment => shipment.selected);
    onConfirm(selected, invoiceNumber, paymentDate, paymentNumber);
    e.preventDefault();
  };

  return (
    <div className="overlay">
      <div className="carrier-payment-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <div className="carrier-payment-grid">
          <div className="carrier-payment-shipments-list">
            <div className="carrier-payment-select-all-buttons">
              <button type="button" onClick={handleSelectAll}>
                Tout sélectionner
              </button>
              <button type="button" onClick={handleDeselectAll}>
                Tout désélectionner
              </button>
            </div>
            <div className="shipments-list carrier-payment">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>N° dossier</th>
                    <th>Date liv</th>
                    <th>Prix tps HT</th>
                  </tr>
                </thead>
                <tbody>
                  {shipments.map((shipment, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          checked={shipment.selected}
                          onChange={() => handleToggleSelect(index)}
                        />
                      </td>
                      <td onClick={() => handleToggleSelect(index)}>{shipment.shipment_number}</td>
                      <td onClick={() => handleToggleSelect(index)}>{shipment.delivery_date}</td>
                      <td onClick={() => handleToggleSelect(index)}>{shipment.carrier_price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="carrier-payment-overview-fields">
            <div className="carrier-payment-overview">
              <p>Montant HT des dossiers sélectionnés</p>
              <p className="sum">{selectedShipmentsSum()} €</p>
            </div>
            <div className="carrier-payment-fields">
              <div className="horizontal-input-group">
                <label>Numéro de facture :</label>
                <input
                  type="text"
                  name="invoice_number"
                  value={invoiceNumber}
                  onChange={handleChangeInvoiceNumber}
                />
              </div>
              <div className="horizontal-input-group">
                <label>Date de règlement :</label>
                <input
                  type="date"
                  name="payment_date"
                  value={paymentDate}
                  onChange={handleChangePaymentDate}
                />
              </div>
              <div className="horizontal-input-group">
                <label>Numéro de règlement :</label>
                <input
                  type="text"
                  name="payment_number"
                  value={paymentNumber}
                  onChange={handleChangePaymentNumber}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="shipment-selector-buttons carrier-payment">
          <button type="button" onClick={onTriggerConfirm}>
            Valider
          </button>
        </div>
      </div>
    </div>
  );
}
